import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { Loading } from 'e4shared';
import { apiGet } from 'services';
import BlobImage from 'components/blobImage';
import { e4Format, isPast } from 'helpers/dates';

export const TeamLateReview = ({ profile }) => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const guid = useSelector(state => (state.user.user ? state.user.user.guid : ''));

    React.useEffect(() => {
        const gotResponse = response => {
            setData(response);
            setLoading(false);
        };

        Boolean(profile) && apiGet(`team-late-review/${profile.id}`, guid, response => gotResponse(response));
    }, [guid, profile.id]);

    return loading ? (
        <Loading />
    ) : (
        <div>
            {data.map(p => {
                return (
                    <div key={`profile-${p.id}`}>
                        <div className="mb5 flex flex-center">
                            <BlobImage
                                height="20"
                                className="img-circle mr5"
                                src={p.avatar}
                                initials={p.initials}
                                folder="avatar"
                            />
                            <span className="mr5">
                                <Link to={`/develop/reviews/${p.id}`}>{p.full_Name}</Link>
                                {p.nextReview && (
                                    <span className="ml5">
                                        Next Review: {e4Format(p.nextReviewe4Format)}
                                        {isPast(p.nextReview) && <label className="label label-danger ml5">OVERDUE</label>}
                                    </span>
                                )}
                            </span>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default TeamLateReview;
